/* Lea Toronto free gift bar for the Lea Toronto cart drawer (#lt-cart, assets/lt-cart.js).
   Tiers come from window.LT_GIFT_TIERS (snippets/lt-gift-bar.liquid). Each gift rings up
   at $0.00 through its own "Free gift" Buy X Get Y automatic discount. Shopify applies only
   one of those discounts per cart, so the customer holds ONE gift: the best tier reached.
   Reaching a higher tier swaps the gift for the better one.
   Above the gift track it shows "Bundle & save" progress (mix & match, any products). */
(function () {
  var TIERS = window.LT_GIFT_TIERS || [];
  if (!TIERS.length) return;

  var BAR_ID = 'lt-gift-bar';
  var DRAWER = '#lt-cart';
  var CART_CALL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var busy = false;
  var pending = false;
  var CHECK = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><path d="M2.5 6.5l2.3 2.3 4.7-5"/></svg>';

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function tierOf(item) {
    for (var i = 0; i < TIERS.length; i++) {
      var t = TIERS[i];
      if (item.variant_id === t.variantId && item.properties && item.properties[t.key]) return t;
    }
    return null;
  }

  // final_line_price leaves out order-level discounts (the bundle %), matching how Shopify checks the gift minimum.
  function paidSubtotal(cart) {
    return cart.items.reduce(function (sum, item) {
      return tierOf(item) ? sum : sum + item.final_line_price;
    }, 0);
  }

  function bestTier(subtotal) {
    var best = null;
    TIERS.forEach(function (t) { if (subtotal >= t.threshold) best = t; });
    return best;
  }

  // Each tier owns an equal share of the track so the stops sit evenly spaced.
  function progress(subtotal) {
    var prev = 0;
    for (var i = 0; i < TIERS.length; i++) {
      var t = TIERS[i].threshold;
      if (subtotal < t) return ((i + (subtotal - prev) / (t - prev)) / TIERS.length) * 100;
      prev = t;
    }
    return 100;
  }

  // "Bundle & save" (mix & match): the "Buy 2/3/4, save 15/20/25%" order discounts need 3/4/5 cart
  // items because Shopify counts the free gift line too; min is that total, items the paid pieces.
  var BUNDLE = [
    { items: 2, min: 3, off: 15 },
    { items: 3, min: 4, off: 20 },
    { items: 4, min: 5, off: 25 }
  ];

  function renderBundle(bar, cart) {
    var box = bar.querySelector('[data-lt-bundle]');
    if (!box) return;
    var count = cart.item_count;
    var paid = cart.items.reduce(function (n, item) { return tierOf(item) ? n : n + item.quantity; }, 0);
    var applied = null;
    var next = null;
    BUNDLE.forEach(function (b) {
      if (count >= b.min) applied = b;
      else if (!next) next = b;
    });
    var more = next ? Math.max(1, next.items - paid) : 0;
    var moreText = '<strong>' + more + ' more item' + (more > 1 ? 's' : '') + '</strong>';
    var html;
    if (applied && next) {
      html = '<strong>' + applied.off + '% off</strong> applied · add ' + moreText + ' to save <strong>' + next.off + '%</strong>';
    } else if (applied) {
      html = '<strong>' + applied.off + '% off</strong> applied: our best bundle deal';
    } else {
      html = 'Add ' + moreText + ' (any product) to save <strong>' + next.off + '%</strong>';
    }
    var msg = box.querySelector('[data-lt-bmsg]');
    if (msg && msg.innerHTML !== html) msg.innerHTML = html;
    BUNDLE.forEach(function (b) {
      var step = box.querySelector('[data-lt-step="' + b.items + '"]');
      if (step) step.classList.toggle('is-reached', count >= b.min);
    });
  }

  function buildBar() {
    var bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.className = 'lt-gift';
    var stops = TIERS.map(function (t, i) {
      return (
        '<div class="lt-gift__stop" data-threshold="' + t.threshold + '" style="left:' + ((i + 1) / TIERS.length) * 100 + '%">' +
          '<div class="lt-gift__thumb">' +
            (t.image ? '<img src="' + t.image + '" alt="' + t.name + '" loading="lazy">' : '') +
            '<span class="lt-gift__check">' + CHECK + '</span>' +
          '</div>' +
          '<span class="lt-gift__amt">' + money(t.threshold) + '</span>' +
          '<span class="lt-gift__name">' + t.name + '</span>' +
        '</div>'
      );
    }).join('');
    var steps = BUNDLE.map(function (b) {
      return '<span class="lt-bprog__step" data-lt-step="' + b.items + '">' + b.items + ' items <b>-' + b.off + '%</b></span>';
    }).join('');
    bar.innerHTML =
      '<div class="lt-bprog" data-lt-bundle>' +
        '<p class="lt-gift__eyebrow">Bundle &amp; save · mix &amp; match</p>' +
        '<p class="lt-gift__msg lt-bprog__msg" data-lt-bmsg></p>' +
        '<div class="lt-bprog__steps">' + steps + '</div>' +
      '</div>' +
      '<p class="lt-gift__eyebrow">Your free gift</p>' +
      '<p class="lt-gift__msg" data-lt-msg></p>' +
      '<div class="lt-gift__rail">' +
        '<div class="lt-gift__track"><div class="lt-gift__fill" data-lt-fill></div></div>' +
        '<div class="lt-gift__stops">' + stops + '</div>' +
      '</div>';
    return bar;
  }

  // Sit at the top of the drawer's scrolling contents so short screens still show the cart items.
  function ensureBar() {
    var root = document.querySelector(DRAWER);
    if (!root) return null;
    var bar = document.getElementById(BAR_ID);
    if (bar && root.contains(bar)) return bar;
    if (bar) bar.remove();
    bar = buildBar();
    var contents = root.querySelector('.lt-cart__contents') || root;
    contents.insertBefore(bar, contents.firstChild);
    return bar;
  }

  function render(cart) {
    var bar = ensureBar();
    if (!bar) return;
    // Hide the bar while the cart is empty.
    bar.style.display = cart.item_count > 0 ? '' : 'none';

    var subtotal = paidSubtotal(cart);
    var fill = bar.querySelector('[data-lt-fill]');
    if (fill) fill.style.width = progress(subtotal) + '%';

    var best = bestTier(subtotal);
    var next = null;
    TIERS.forEach(function (t) {
      var reached = subtotal >= t.threshold;
      var stop = bar.querySelector('.lt-gift__stop[data-threshold="' + t.threshold + '"]');
      if (stop) {
        stop.classList.toggle('is-reached', t === best);
        stop.classList.toggle('is-passed', reached && t !== best);
      }
      if (!reached && !next) next = t;
    });

    var msg = bar.querySelector('[data-lt-msg]');
    if (msg) {
      var html = next
        ? 'You’re <strong>' + money(next.threshold - subtotal) + '</strong> away from ' +
          (best ? 'upgrading to ' : '') + '<strong>' + (next.unlock || 'a free ' + next.name) + '</strong>'
        : 'You’ve unlocked our best gift: <strong>' + (best.unlock || best.name) + '</strong>';
      if (msg.innerHTML !== html) msg.innerHTML = html;
    }
    renderBundle(bar, cart);
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }

  // Keep exactly one gift line (the best tier reached, quantity 1) and remove any others.
  function sync(cart) {
    var best = bestTier(paidSubtotal(cart));
    var hasBest = false;
    var actions = [];
    cart.items.forEach(function (item) {
      var t = tierOf(item);
      if (!t) return;
      if (t === best && !hasBest) {
        hasBest = true;
        if (item.quantity !== 1) actions.push({ key: item.key, qty: 1 });
      } else {
        actions.push({ key: item.key, qty: 0 });
      }
    });
    if (best && !hasBest) actions.push({ add: best });

    if (!actions.length) {
      render(cart);
      return Promise.resolve();
    }
    busy = true;
    return actions
      .reduce(function (p, a) {
        return p.then(function () {
          if (a.add) {
            var props = {};
            props[a.add.key] = 'true';
            return post('/cart/add.js', { items: [{ id: a.add.variantId, quantity: 1, properties: props }] });
          }
          return post('/cart/change.js', { id: a.key, quantity: a.qty });
        });
      }, Promise.resolve())
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        busy = false;
        render(c);
        // Let the cart drawer re-render with the updated gift line.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (pending) { pending = false; refresh(); }
      })
      .catch(function () { busy = false; });
  }

  function refresh() {
    if (busy) { pending = true; return Promise.resolve(); }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(sync).catch(function () {});
  }

  // Re-sync after any AJAX cart call, from the theme, the cart drawer or an app.
  var origFetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = typeof a === 'string' ? a : a && a.url;
    var isCart = typeof url === 'string' && CART_CALL.test(url);
    return origFetch.apply(this, arguments).then(function (res) {
      if (isCart && !busy) setTimeout(refresh, 80);
      return res;
    });
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_CALL.test(url)) {
      this.addEventListener('load', function () { if (!busy) setTimeout(refresh, 80); });
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();